import { Injectable, Injector } from '@angular/core';
import { DocumentGroups } from '@carm/_core';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Observable } from 'rxjs';
import { IValidateCaseNumberResponse } from '../models/case.model';

@Injectable()
export class CaseService extends BaseApiService {
  constructor(protected injector: Injector, public userService: UserService) {
    super(injector);
  }

  validateCaseIdByBP(caseId: string, group: DocumentGroups): Observable<IValidateCaseNumberResponse> {
    const endpoint = `${this.endPointBP}/case/${caseId}/group/${group.toString()}/validate`;
    return this.httpAuthGet<IValidateCaseNumberResponse>(endpoint);
  }

  validateCaseIdByB(caseId: string, group: DocumentGroups): Observable<IValidateCaseNumberResponse> {
    const endpoint = `${this.endPointB}/case/${caseId}/group/${group.toString()}/validate`;
    return this.httpAuthGet<IValidateCaseNumberResponse>(endpoint);
  }
}
